import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import OverrideFeesForm from './OverrideFeesForm';

import { Spinner } from 'admin-components/components';
import { Row, Column } from 'components/shared/Layout';

import { StyledButton, StyledOverrideTitleRow } from './OverrideFeesCta.styles';

const OverrideFeesCta = ({
  onSubmit,
  showLink,
  includeReason,
  includeFareDiff,
  includeOfflineFee,
  includeExchangeFee,
  includeCancellationFee,
  includeHotelCancellationFee,
  includeRepricing,
  loading = false,
  waiveFeesWarning
}) => {
  const [showForm, openForm] = useState(false);
  const handleLinkClick = () => openForm(true);

  if (loading) {
    return (
      <Row span={16}>
        <Column justifyContent="center" alignItems="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  return (
    <>
      {showLink && (
        <StyledOverrideTitleRow>
          <Column span={3}>
            <StyledButton data-cy="override-fees-link" onClick={handleLinkClick}>
              <FormattedMessage id="overrideFees.cta" />
            </StyledButton>
          </Column>
        </StyledOverrideTitleRow>
      )}
      {showForm && (
        <OverrideFeesForm
          onSubmit={onSubmit}
          includeReason={includeReason}
          includeFareDiff={includeFareDiff}
          includeOfflineFee={includeOfflineFee}
          includeExchangeFee={includeExchangeFee}
          includeRepricing={includeRepricing}
          includeCancellationFee={includeCancellationFee}
          includeHotelCancellationFee={includeHotelCancellationFee}
          waiveFeesWarning={waiveFeesWarning}
        />
      )}
    </>
  );
};

OverrideFeesCta.propTypes = {
  showLink: PropTypes.bool,
  onSubmit: PropTypes.func,
  includeReason: PropTypes.bool,
  includeFareDiff: PropTypes.bool,
  includeExchangeFee: PropTypes.bool,
  includeOfflineFee: PropTypes.bool,
  includeCancellationFee: PropTypes.bool,
  includeRepricing: PropTypes.bool,
  includeHotelCancellationFee: PropTypes.bool,
  loading: PropTypes.bool,
  waiveFeesWarning: PropTypes.node
};

export default OverrideFeesCta;
